<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn link
             color="primary"
             to="/cadastro-cotacao-frete"
             class="rounded-tag-small normal-btn-text elevation-0">
        <v-icon left>mdi-plus</v-icon>
        Cotação de frete
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text class="rounded-tag-small"
                      label="Busque por uma transportadora ou identificador"
                      style="max-width: 400px"
                      v-model="searchText"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange"/>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['ABERTA', 'COMPRA'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'FINALIZADAS',
          description: 'Finalizadas',
          value: ['FINALIZADA'],
        },
      ],
    };
  },
  computed: {
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCotacaoFrete/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCotacaoFrete/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCotacaoFrete/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCotacaoFrete/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  created() {
    [this.selectedStatus] = this.statusOptions;
  },
};
</script>
